import type { Event } from '../types';

export const GlobalEventData = {
  SignupEnteredStep: {
    eventAction: 'EnteredStep',
  } as Event<''>,
  SignupCompletedStep: {
    eventAction: 'CompletedStep',
  } as Event<''>,
  LoadingRecord: {
    eventAction: 'LoadingRecord',
  } as Event<string>,
  HelpModalOpen: {
    eventAction: 'HelpModalOpen',
  } as Event<string>,
  HelpModalContactUsViewed: {
    eventAction: 'HelpModalContactUsViewed',
  } as Event<string>,
  SubmitFeedback: {
    eventAction: 'SubmitFeedback',
  } as Event<string>,
  HelpPhoneCallClick: {
    eventAction: 'HelpPhoneCallClick',
  } as Event<string>,
  PageView: {
    eventAction: 'Page',
  } as Event<string>,
  Error: {
    eventAction: 'Error',
  } as Event<string>,
  FetchIPAddress: {
    eventAction: 'FetchIPAddress',
  } as Event<string>,
  IPQS: {
    eventAction: 'IPQS',
  } as Event<string>,
  OptionListSearch: {
    eventAction: 'OptionListSearch',
  } as Event<string>,
  OptionListShowMore: {
    eventAction: 'OptionListShowMore',
  } as Event<string>,
  AddressSearch: {
    eventAction: 'AddressSearch',
  } as Event<string>,
};
